// -------------------------------------------------------------------------------------------------
// #region Provider Query Keys
// -------------------------------------------------------------------------------------------------

const EventQueryKeys = {
    EVENT_LIST: "eventList",
};

const ProviderQueryKeys = {
    PROVIDER_GOAL: "providerGoal",
    PROVIDER_SUMMARY: "providerSummary",
};

const OrganizationQueryKeys = {
    ORGANIZATION_EVENT_SUMMARY: "organizationEventSummary",
    ORGANIZATION_EVENT_LIST: "organizationEventList",
};

const ProviderFeeInvoiceQueryKeys = {
    PROVIDER_FEE_INVOICE_LIST: "providerFeeInvoiceList",
};

// #endregion Provider Query Keys

// -------------------------------------------------------------------------------------------------
// #region Query Keys Export
// -------------------------------------------------------------------------------------------------

export const QUERY_KEYS = {
    ...EventQueryKeys,
    ...ProviderQueryKeys,
    ...OrganizationQueryKeys,
    ...ProviderFeeInvoiceQueryKeys,
};

// #endregion Query Keys
